import React from 'react';

import styled from '@emotion/styled';

import { CustomLink } from '@shared/custom_link';

import { darkFooterLinkStyles } from './dark_footer_link_styles';

/** Temporary until Cookiebot launches; then switch back to the preferences modal. */
const CALIFORNIA_DO_NOT_SELL_PATH =
  '/legal/california_privacy_rights#information-sharing';

const FooterLink = styled(CustomLink)`
  ${darkFooterLinkStyles}
`;

export const PrivacyPreferencesFooterLink: React.FC = () => (
  <FooterLink to={CALIFORNIA_DO_NOT_SELL_PATH}>
    Do not sell or share my personal information
  </FooterLink>
);
